import { IS_USER_AUTHENTICATED, GET_SELLER } from "./const";

export default {
    [IS_USER_AUTHENTICATED](state) {
        return state.authenticated;
    },

    [GET_SELLER](state) {
        return state.seller;
    }
}